/**
 * UI sound ids played through `useServices().audio.sfx(id)`. The audio team maps them in the @hf/audio SFX bank
 * (unknown ids are no-ops, so the UI never breaks if a sound is missing).
 */
import type { AudioEngine } from '@hf/audio';

export const UI_SFX = {
  move: 'ui_move',
  confirm: 'ui_confirm',
  back: 'ui_back',
  error: 'ui_error',
  toggle: 'ui_toggle',
  whoosh: 'ui_whoosh',
  slam: 'ui_slam',
  ready: 'ui_ready',
  start: 'ui_start',
} as const;
export type UiSfx = (typeof UI_SFX)[keyof typeof UI_SFX];

/** Fire-and-forget; never throws (audio may be locked before the first gesture). */
export const playSfx = (audio: AudioEngine | null | undefined, id: UiSfx): void => {
  try {
    audio?.sfx(id);
  } catch {
    /* audio is optional for the UI */
  }
};
